module.exports = __webpack_public_path__ + "static/media/fam01.45cc4f13.jpg";